import React from "react";
import { CSVLink } from "react-csv";
import { FilterIcon } from "icons";
import { csvHeaders } from "../utils";
import { capitalize } from "content/utils/commonParsing";

const RightSection = ({
  classes,
  showFilter,
  setShowFilter,
  upcoming,
  CSVData,
  attendeesCount,
  filename,
}) => {
  const [csv, setCsv] = React.useState([]);
  const getTableData = () => {
    if (CSVData) {
      let filterValue = [];
      CSVData.map((e) => {
        let status = !upcoming && e.attended ? "Attended" : capitalize(e.status);
        filterValue.push({
          ...e,
          status: status == "Canceled" ? "RSVPed Canceled" : status,
          isResident: e.isResident ? "Resident" : "Prospect",
        });
      });
      return filterValue;
    } else {
      return [];
    }
  };

  React.useEffect(() => {
    setCsv(getTableData());
  }, [CSVData]);
  return (
    <div className={classes.flexBox}>
      <FilterIcon
        className={`${classes.filterIcon} ${!showFilter && classes.inactive}`}
        onClick={setShowFilter.bind(this, !showFilter)}
      />
      <div className={classes.divider}></div>
      {upcoming ? "RSVPed:" : "Attended:"}
      <div className={classes.count}>
        &nbsp; {upcoming ? attendeesCount.allRsvp : attendeesCount.allAttended}
      </div>
      <div className={classes.divider}></div>
      <CSVLink data={csv} headers={csvHeaders} filename={filename}>
        <div className={classes.CsvIcon}>Export CSV</div>
      </CSVLink>
    </div>
  );
};

export default RightSection;
